export default async function fetchUpdateUser(token: string) {
  try {
    const res = await fetch("/api/update-user", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ token })
    });
    const data = (await res.json()) as { ok: boolean };
    return {
      data,
      error: null
    };
  } catch (err) {
    console.error(err);
    return { data: null, error: err };
  }
}
